import React from 'react';

type BadgeVariant = 'valid' | 'expiring' | 'suspended' | 'review' | 'pending' | 'approved' | 'completed' | 'progress';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
  size?: 'sm' | 'md';
}

const variantClasses: Record<BadgeVariant, string> = {
  valid: 'badge-valid',
  expiring: 'badge-expiring',
  suspended: 'badge-suspended',
  review: 'badge-review',
  pending: 'badge-pending',
  approved: 'badge-valid',
  completed: 'verified-badge',
  progress: 'badge-review',
};

export default function StatusBadge({ variant, label, size = 'sm' }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${variantClasses[variant]} ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'
      }`}
    >
      {label}
    </span>
  );
}